import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Box from '@bit/knotchinc.web-react-components.box';
import { connect } from 'react-redux';
import { Page } from '@bit/knotchinc.web-react-components.page';
import PageHeader from 'components/Global/PageHeader/PageHeader.jsx';
import { fetchBrandMetadata } from 'components/Pages/Entity/actions';
import { createEntityCompetitor, removeEntityCompetitor, createEntitySubscription, removeEntitySubscription } from 'components/Pages/Settings/actions.js';
import BrandInsightsView from 'components/Pages/Entity/BrandInsightsView.jsx';
import BrandOwnedInsightsView from 'components/Pages/Entity/BrandOwnedInsightsView.jsx';
import BrandPaidContentView from './PaidContent/BrandPaidContentView.jsx';
import BrandOwnedContentView from './OwnedContent/BrandOwnedContentView.jsx';
import { SET_KEYWORDS_FILTER } from 'components/Global/Filters/actions.js';

class BrandView extends React.Component {
  componentDidMount() {
    this.props.setKeywordsFilters();
    this.props.getMetadata();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.entityId !== this.props.match.params.entityId) {
      this.props.getMetadata();
    }
  }

  render() {
    const { userEntity, match, metadata, postCompetitor, deleteCompetitor, postSubscription, deleteSubscription } = this.props;
    const { data, fetched } = metadata;

    const paidContentTabs = [
      { text: 'Paid Content', title: 'Paid Content', link: `${match.url}/paid` },
      { text: 'Paid Analytics', title: 'Paid Analytics', link: `${match.url}/analytics` },
    ];

    const ownedAndPaidContentTabs = [
      { text: 'Paid Content', title: 'Paid Content', link: `${match.url}/paid` },
      { text: 'Owned Content', title: 'Owned Content', link: `${match.url}/owned` },
      { text: 'Paid Analytics', title: 'Paid Analytics', link: `${match.url}/analytics` },
      { text: 'Owned Analytics', title: 'Owned Analytics', link: `${match.url}/owned_analytics` },
    ];

    const actions = [
      {
        text: 'Subscribe',
        selectedText: 'Subscribed',
        action: () => data.is_subscribed ? deleteSubscription() : postSubscription(),
        selected: data.is_subscribed,
      },
    ];

    if (userEntity && userEntity.type === 'brand') {
      actions.push({
        text: 'Add Competitor',
        selectedText: 'Remove Competitor',
        action: () => data.is_competitor ? deleteCompetitor() : postCompetitor(),
        selected: data.is_competitor,
      });
    }

    return (
      <Page>
        <Box height="320px">
          <PageHeader
            entityLogo={data.logo_url}
            bg={data.banner_image_url}
            title={data.name}
            fetched={fetched}
            tabs={data.has_hubs ? ownedAndPaidContentTabs : paidContentTabs}
            actionButtons={actions}
          />
        </Box>
        <Switch>
          <Redirect exact from={match.path} to={`${match.path}/paid`} />
          <Route exact path={`${match.path}/paid`} component={BrandPaidContentView} />
          <Route exact path={`${match.path}/owned`} component={BrandOwnedContentView} />
          <Route exact path={`${match.path}/analytics`} render={props => <BrandInsightsView entityType="brand" {...props} />} />
          <Route exact path={`${match.path}/owned_analytics`} render={props => <BrandOwnedInsightsView entityType="brand" {...props} />} />
        </Switch>
      </Page>
    );
  }
}

const mapStateToProps = ({
  BrandProfile: { metadata },
  Account: { userEntity },
}) => ({ userEntity, metadata });

const mapDispatchToProps = (dispatch, { match: { params: { entityId } } }) => ({
  getMetadata: () => dispatch(fetchBrandMetadata(entityId)),
  postCompetitor: () => dispatch(createEntityCompetitor(entityId, 'brand')),
  deleteCompetitor: () => dispatch(removeEntityCompetitor(entityId, 'brand')),
  postSubscription: () => dispatch(createEntitySubscription(entityId, 'brand')),
  deleteSubscription: () => dispatch(removeEntitySubscription(entityId, 'brand')),
  setKeywordsFilters: () => dispatch({ type: SET_KEYWORDS_FILTER, filters: { sortOrder: 'desc', sortBy: 'num_contents' } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(BrandView);

